import React from "react";

export default function PaymentSuccessModal({ open, details, onClose }) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(2,6,23,0.72)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 520,
          borderRadius: 24,
          background: "#ffffff",
          color: "#111827",
          padding: 28,
          boxShadow: "0 30px 80px rgba(0,0,0,0.35)",
          border: "1px solid #d1d5db",
        }}
      >
        <div
          style={{
            width: 62,
            height: 62,
            borderRadius: "50%",
            background: "#dcfce7",
            color: "#166534",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 34,
            fontWeight: 900,
            marginBottom: 18,
          }}
        >
          ✓
        </div>

        <h2 style={{ margin: "0 0 8px", fontSize: 28 }}>Payment Successful</h2>
        <p style={{ margin: "0 0 18px", color: "#4b5563", lineHeight: 1.6 }}>
          Your Starter subscription has been activated. Premium features like uploads,
          reports, PDF export, and print are now unlocked.
        </p>

        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e5e7eb",
            borderRadius: 16,
            padding: 16,
            marginBottom: 18,
          }}
        >
          <Row label="Plan" value={details?.planName || "Starter"} />
          <Row label="Provider" value={details?.provider || "Payment Gateway"} />
          <Row label="Status" value="Active" />
        </div>

        <button
          onClick={onClose}
          style={{
            width: "100%",
            padding: 14,
            borderRadius: 14,
            border: "none",
            background: "#2563eb",
            color: "#ffffff",
            fontWeight: 900,
            cursor: "pointer",
          }}
        >
          Continue to Dashboard
        </button>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 16, marginBottom: 10 }}>
      <span style={{ color: "#6b7280", fontWeight: 700 }}>{label}</span>
      <span style={{ color: "#111827", fontWeight: 900 }}>{value}</span>
    </div>
  );
}
